// extracted by mini-css-extract-plugin
module.exports = {"navContainter":"NavSteps_navContainter__3Szuo","navElement":"NavSteps_navElement__qGWEA"};